module.exports = __webpack_public_path__ + "img/gh-12132____.prt.05168513.jpg";